// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Network_networkCard__V3Jdo {
  margin-bottom: 20px;
}
.Network_networkCard__V3Jdo .ant-card-head-title {
  font-weight: bold;
}

.Network_expandedRow__X7xXy {
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 4px;
}
.Network_expandedRow__X7xXy h4 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: bold;
}
.Network_expandedRow__X7xXy ul {
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Detail/component/network/Network.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEI;EACE,iBAAA;AAAN;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AAFF;AAIE;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,iBAAA;AAHJ","sourcesContent":[".networkCard {\n  margin-bottom: 20px;\n  \n  :global {\n    .ant-card-head-title {\n      font-weight: bold;\n    }\n  }\n}\n\n.expandedRow {\n  padding: 16px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  \n  h4 {\n    margin-top: 16px;\n    margin-bottom: 8px;\n    font-weight: bold;\n  }\n  \n  ul {\n    margin-left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"networkCard": `Network_networkCard__V3Jdo`,
	"expandedRow": `Network_expandedRow__X7xXy`
};
export default ___CSS_LOADER_EXPORT___;
